<template>
  <el-dialog
    title="Tarife Listesi"
    :visible="Modal"
    center
    width="50%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="Tarife Listesi" name="1">
        <table class="table table-sm">
          <thead>
          <tr>
            <th>Tarife Adı</th>
            <th>Hız Limiti</th>
            <th>Kota</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="t in TarifeListe">
            <td>{{t.TarifeAdi}}</td>
            <td>{{t.Hiz}}</td>
            <td>{{t.sTur}} {{t.gKota}}</td>
            <td width="50">
              <el-tooltip class="item" effect="dark" content="Tarife Düzenle"
                          placement="top-start">
                <a href="#" @click="Duzenle(t)" class="text-info mr-1"> <i class="feather-edit-2"></i></a>
              </el-tooltip>
              <el-tooltip class="item" effect="dark"
                          content="Tarife Sil"
                          placement="top-start">
                <a href="#" @click="SilOnay(t.id,t.Bina_id)" class="text-danger"> <i
                  class="el-icon-delete-solid"></i></a>
              </el-tooltip>
            </td>
          </tr>
          </tbody>
        </table>
      </el-collapse-item>
      <el-collapse-item :title="TarifeText" name="2">
        <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Tarife Adı" prop="TarifeAdi">
                <el-input v-model="Form.TarifeAdi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Hız Limiti" prop="Hiz">
                <el-select v-model="Form.Hiz" filterable>
                  <el-option
                    v-for="item in Hizlar"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Kota Türü" prop="sTur">
                <el-select v-model="Form.sTur" filterable clearable>
                  <el-option
                    v-for="item in KotaTur"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="Form.sTur">
              <el-form-item :label="Form.sTur+' Kota'" prop="sKota">
                <el-input v-model="Form.gKota"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <hr>
        <div class="dialog-footer text-center">
          <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
            Kaydet
          </el-button>
          <el-button type="danger" size="small" v-if="Form.id" :disabled="lo" @click="SayfaYukle()"
                     icon="el-icon-close">
            Düzenlemeyi İptal Et
          </el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-dialog>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['Modal', 'Bina_id'],
    data() {
      return {
        Hizlar: ["1024K/4096K", "1024K/60144K", "2048K/80192K", "2048K/12288K", "2048K/16384K", "4096K/24576K"],
        KotaTur: ["Günlük", "Haftalık", "Aylık", "Total"],
        activeNames: ['1'],
        lo: false,
        TarifeListe: null,
        TarifeText: 'Tarife Ekle',
        Form: {
          TarifeAdi: null,
          Hiz: null,
          sTur: null,
          gKota: null,
          Bina_id: this.Bina_id,
          id: null
        },
        FormHata: {
          TarifeAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Hiz: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }
      }
    },
    methods: {
      Duzenle(data) {
        this.activeNames = ['2'];
        this.TarifeText = 'Tarife Düzenle';
        this.Form = data;
      },
      SilOnay(id, Bina_id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id, Bina_id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id, Bina_id) {
        this.$store.dispatch("Delete", {...this.Form, path: '_radius/tarife/' + id + '/' + this.Bina_id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      SayfaYukle() {
        this.activeNames = ['1'];
        this.lo = true;
        this.TarifeText = 'Tarife Ekle';
        this.Form = {
          TarifeAdi: null,
          Hiz: null,
          sTur: null,
          gKota: null,
          Bina_id: this.Bina_id,
          id: null
        };
        this.$store.dispatch("Get", {path: '_radius/tarife/' + this.Bina_id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.TarifeListe = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.Form.Bina_id = this.Bina_id;
            this.lo = true;
            this.$store.dispatch("Post", {
              ...this.Form,
              path: '_radius/tarife/' + this.Bina_id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle();
                  this.$message.success("Radius Bilgileri kayıt edilmiştir.");
                } else {
                  this.$message.error(response.Mesaj);
                }
              })
          }
        })
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/TarifeModal.vue